import defaultView from './default.vue'
import pc from './pc.vue'
import pad from "./pad"
export default {
  defaultView,
  pc,
  pad
}
